import { useState } from 'react'

export const useOverlayToggle = () => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false)

  const handleOverlayToggle = () => setIsOverlayVisible(!isOverlayVisible)

  return { isOverlayVisible, handleOverlayToggle, setIsOverlayVisible }
}
